import { exerciseWeekQueryOptions } from '@/src/queries/exercise-queries'
import { getCurrentYearWeek } from '@/src/utils/year-week'
import { useSuspenseQuery } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { StatisticsMetricCard } from '../StatisticsMetricCard'

export function ExercisesThisWeekMetricCard() {
  const { t } = useTranslation(['statistics', 'common'])
  const yearWeek = getCurrentYearWeek()
  const exerciseWeekCountQuery = useSuspenseQuery({
    ...exerciseWeekQueryOptions(yearWeek),
    select: (data) => ({ total: data.length }),
  })
  const exercisesThisWeek = exerciseWeekCountQuery.data.total

  return (
    <StatisticsMetricCard
      id="exercises"
      title={t('statistics:metric_exercises_title')}
      value={t('statistics:metric_exercises_value_completed', {
        count: exercisesThisWeek ?? 0,
      })}
      timeframe={t('statistics:timeframe_this_week')}
      iconName="exercise"
    />
  )
}
